import React from "react";

import {DEFAULT_EXPERT} from "../constants/default_expert";
import {IExpertOpinion} from "../types/IExpertOpinion";
import {PricesArticlesList} from "./PricesArticlesList";
import {PricesExpert} from "./PricesExpert";

export const PricesGeneralArticles = () => {
    const expertOpinion: IExpertOpinion = {
        ...DEFAULT_EXPERT,
        title: "Ceny mieszkań - komentarz eksperta",
        text: "Ceny mieszkań w Polsce od długiego czasu są jednym z głównych tematów dyskusji w przestrzeni publicznej. Chodzi oczywiście o ich horrendalne wzrosty, spowodowane programem Bezpieczny Kredyt 2%. Obecnie, na szczęście, sytuacja na rynku się stabilizuje. Dynamika wzrostu średniej ceny metra kwadratowego maleje. Oferta mieszkań powoli się odbudowuje. Co więcej, w ofertach firm deweloperskich zaczęło pojawiać się wiele atrakcyjnych rabatów i promocji, które pozwalają na zaoszczędzenie nawet kilkudziesięciu tysięcy złotych! "
    };

    return (
        <div>
            <PricesExpert expertOpinion={expertOpinion} />

            <PricesArticlesList />
        </div>
    );
};
import React from "react";

import {DEFAULT_EXPERT} from "../constants/default_expert";
import {IExpertOpinion} from "../types/IExpertOpinion";
import {PricesArticlesList} from "./PricesArticlesList";
import {PricesExpert} from "./PricesExpert";

export const PricesGeneralArticles = () => {
    const expertOpinion: IExpertOpinion = {
        ...DEFAULT_EXPERT,
        title: "Ceny mieszkań - komentarz eksperta",
        text: "Ceny mieszkań w Polsce od długiego czasu są jednym z głównych tematów dyskusji w przestrzeni publicznej. Chodzi oczywiście o ich horrendalne wzrosty, spowodowane programem Bezpieczny Kredyt 2%. Obecnie, na szczęście, sytuacja na rynku się stabilizuje. Dynamika wzrostu średniej ceny metra kwadratowego maleje. Oferta mieszkań powoli się odbudowuje. Co więcej, w ofertach firm deweloperskich zaczęło pojawiać się wiele atrakcyjnych rabatów i promocji, które pozwalają na zaoszczędzenie nawet kilkudziesięciu tysięcy złotych! "
    };

    return (
        <div>
            <PricesExpert expertOpinion={expertOpinion} />

            <PricesArticlesList />
        </div>
    );
};
